import { render, staticRenderFns } from "./Transport_Component.vue?vue&type=template&id=4569acb5&scoped=true&"
import script from "./Transport_Component.vue?vue&type=script&lang=js&"
export * from "./Transport_Component.vue?vue&type=script&lang=js&"
import style0 from "./Transport_Component.vue?vue&type=style&index=0&id=4569acb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4569acb5",
  null
  
)

export default component.exports